export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Cobalt Blue.659edf9c.jpg";